import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { ApiTitleComponent } from '../../common/api-title/api-title.component';
import { ApiUIResponseComponent } from '../api-ui-response/api-ui-response.component';
import { GlobalContants, Resource } from 'src/app/constants/global.contants';
import { environment } from 'src/environments/environment';
import { SharedService } from 'src/app/services/shared.service';
import { UserService } from 'src/app/services/user.service';
import { HTTPMethod } from 'src/app/constants/enum';
import { apiEndPoints } from 'src/app/constants/api-endpointsconstant';

export interface statusCode {
  key: string;
  value: string;
  required: boolean
}

const Headers: statusCode[] = [
  {
    key: "Content-Type",
    value: 'application/json',
    required: false
  },
  {
    key: "API-KEY",
    value: '{{API-KEY}}',
    required: true
  },
  {
    key: "USER-TOKEN",
    value: '{{USER-TOKEN}}',
    required: true
  },
  {
    key: "CITY-CODE",
    value: '{{CITY-CODE}}',
    required: true
  },
];
const QueryData: any = [
  {
    param: "limit",
    value: '{{limit}}',
    required: false
  },
  {
    param: "offset",
    value: '{{offset}}',
    required: false
  },
  {
    param: "filter",
    value: '{{filter}} Filter value in json format e.g.',
    code: `{
  "property_uid": "",
  "floor_uid": "",
  "unit_uid":"",
  "unit_type": "",
  "unit_sub_type": "",
  "category": "",
  "shop_name": "",
  "unit_number": "",
  "unit_area": "",
}`,
    required: false
  }
]

@Component({
  selector: 'app-dallal-unit',
  standalone: true,
  imports: [CommonModule,
    MaterialModule,
    RouterModule,
    ApiTitleComponent,
    ApiUIResponseComponent,],
  templateUrl: './dallal-unit.component.html',
})
export class DallalUnitComponent {
  HTTPMethod = HTTPMethod;
  displayedColumns: string[] = ['key', 'value', 'required'];
  QueryColumns: string[] = ['param', 'value', 'required'];
  dataSource = Headers;
  QueryDataSource = QueryData;

  api_ui: boolean = false;

  GlobalContants = GlobalContants
  constructor(private sharedService: SharedService,
    private userService: UserService,
    private router: Router) {

  }

  ngOnInit() {
    let userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
    this.userService.getAllUserResource(userInfo.user_id)
      .subscribe({
        next: (res: any) => {
          const matched = res.data.find((r: any) => r.resource_name === Resource.Unit);
          if (!matched?.methods?.includes(HTTPMethod.GET)) {
            this.router.navigate(['/'])
          }
        },
        error: (err) => {
        }
      })
  }

  ngAfterViewInit() {
  }

  api_demo = `${environment.apiBaseUrl}${apiEndPoints.units}`;

  api_response = `
{
  "status": 0,
  "message": "string",
  "data": 
    [
      {
        "property_uid": "TSTLA00000",
        "unit_uid": "TSTUA00003",
        "floor_uid": "TSTFA00001",
        "unit_type": "retail",
        "unit_sub_type": "retail",
        "unit_area": 186.36553,
        "unit_number": "B 24",
        "category": null,
        "shop_name": null,
        "sub_category": null,
        "cuisine": null,
        "no_of_full_bathroom": null,
        "no_of_half_bathroom": null,
        "no_of_master_bedroom": null,
        "parent_unit_uid": null,
        "no_of_balcony": null,
        "no_of_bedroom": null,
        "no_of_kitchen": null,
        "no_of_living_room": null,
        "no_of_diwania": null,
        "no_of_driver_room": null,
        "no_of_maid_room": null,
        "unit_name": null,
        "main_category": null,
        "department": null
      }
    ]
}`;
}
